import { useEffect, useState } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetServiceAddrType/Main";
import Form from "./TbSetServiceAddrType/Form";

// Utils
import { getAlert, getData } from "../../../utils/SamuiUtils";

const TbSetServiceAddrType = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState([]);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getData(
        "Tb_Set_ServiceAddrType",
        "1=1 ORDER BY ServiceAddr_Type_Id"
      );
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      } else {
        setDataMasterList([]);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      ServiceAddr_Type_Id: item.ServiceAddr_Type_Id,
      ServiceAddr_Type_Name: item.ServiceAddr_Type_Name || "",
      ServiceAddr_Type_Status: item.ServiceAddr_Type_Status || "Y",
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ประเภทอาคาร"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ประเภทอาคาร"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetServiceAddrType;
